
// initial state
const state = {
  countries: [],
};

const mutations = {
  setCountries(currentState, countries = []) {
    currentState.countries = countries;
  },
};

export { mutations, state };
